import React, { useState } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";

export default function BuySide() {
	const [activeTooltip, setActiveTooltip] = useState(null);

	const handleMouseEnter = (template) => {
		setActiveTooltip(template);
	};

	const handleMouseLeave = () => {
		setActiveTooltip(null);
	};
	return (
		<div>
			<HelmetProvider>
				<Helmet>
					<title>Transaktionsberatung</title>
					<meta name="description" content="Transaktionsberatung" />
					<meta
						name="keywords"
						content="Transaktionsberatung, Feingeist, Berlin"
					/>
				</Helmet>
			</HelmetProvider>
			<div className="beratung_cont" id="buy_side">
				<h1>Wir unterstützen Sie Ihre Wachstumsziele zu erreichen</h1>
				<p>
					Die Feingeist Beratung begleitet Sie pragmatisch im Rahmen der
					Transaktionsberatung mit unseren Experten bei Ihrer
					Wachstumsstrategie.
				</p>
				<h2>Ihre Vorteile:</h2>
				<ul className="typeset-u-list">
					<li>
						Effizienter Ankaufprozess mit anschließender Integrationsbegleitung
					</li>
					<li>Umfangreiche Kenntnisse zur marktnahen Bewertung von Targets</li>
					<li>Diskrete Ansprache potentieller Verkäufer bzw. Entscheider</li>
					<li>Bewährte systematische Ansätze bei Buy-and-Build- Strategien</li>
					<li>Umfangreiche Erfahrung mit alternativen Kapitalbeschaffungen</li>
				</ul>
				<p>
					Als erfahrene Unternehmensberatung helfen wir neue
					Wachstumsmöglichkeiten (bspw. mit einer Buy-and-Build- Strategie) zu
					erarbeiten und gleichzeitig die Risiken, die mit einer Übernahme
					verbunden sind, aufzudecken und zu minimieren.
				</p>
				<p>Der Prozess sieht dabei wie folgt aus:</p>

				<img
					src="https://feingeist-beratung.de/wp-content/uploads/2024/02/transaktionsprozesse-diagramm.png"
					alt="Diagram: Weg zur Digitagstrategie"
					className="svg_transaktion"
					useMap="#transaktionsprozesse"
					aria-label="Hey tooltip!"
					data-microtip-position="top"
				/>

				<p>
					Nach Abschluss des Transaktionsprozesses können wir Sie bei der
					Integration mit erfahrenen Strategie- und Organisationsberatern
					unterstützen.
				</p>
				<p>Sprechen Sie uns an.</p>
			</div>
		</div>
	);
}
